import { useQuery } from '@apollo/client';
import Background from '@do/walrus/Background';
import Button from '@do/walrus/Button';
import Text from '@do/walrus/Text';
import React, { ReactElement } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import useReactRouter from 'use-react-router';
import defaultBg from '../assets/backgrounds/Login_Default.jpg';
import copy from '../copy';
import { GetPasswordResetInfo } from '../generated-types/GetPasswordResetInfo';
import useDocumentTitle from '../hooks/use-document-title';
import { GET_PASSWORD_RESET_FORM_DATA } from '../queries/queries';
import { FormWrap, Loading, PaddedContents, Wrap } from './Common';
import Header from './Header';
import PasswordResetForm from './PasswordResetForm';

function PasswordReset({ location }: RouteComponentProps): ReactElement {
  const token = location.pathname.split('/').pop() || '';
  const { loading: isLoading, error } = useQuery<GetPasswordResetInfo>(
    GET_PASSWORD_RESET_FORM_DATA,
    {
      variables: {
        token
      }
    }
  );

  const { history } = useReactRouter();
  useDocumentTitle(copy.form.password_reset_title);

  if (isLoading) {
    return <Loading isLogin={true} />;
  }

  return (
    <>
      <Header isLogin={true} />
      <Background url={defaultBg} />
      <Wrap>
        <FormWrap>
          <PaddedContents>
            <h4>
              {!error
                ? copy.form.password_reset.title
                : copy.form.password_reset.error_title}
            </h4>
            <Text>
              {!error
                ? copy.form.password_reset.details
                : copy.form.password_reset.error_details}
            </Text>
            {!error ? (
              <PasswordResetForm token={token} />
            ) : (
              <Button
                onClick={() => history.push('/forgot_password/new')}
                fullWidth
              >
                {copy.form.password_reset.button_text}
              </Button>
            )}
          </PaddedContents>
        </FormWrap>
      </Wrap>
    </>
  );
}

export default PasswordReset;
